import React from "react";
import { connect } from "react-redux";
import I18n from "../../I18n";
import { logout, setLocale } from "../../store/actions";
import styles from "./NotFound.module.sass";
import { ActionButton } from "colbi_web_ui/lib/components/inputs";
import { SovosBox } from "mosaic-react";
import { handleClickGoBack, handleClickGoHome } from "../../utils/navigationUtils";

const NotFound = (props) => {
    const { match, history } = props;
    const locale = match.params.locale || "en";
    const i18n = I18n.use(locale);

    return (
        <SovosBox className={`${styles["notfound"]} ${styles["center-icon"] ?? ""}`}>
            <SovosBox className={styles["notfound-description"]}>
                <h2>{i18n`not_found`}</h2>
                <h1 className={styles["notfound-404"]}>404</h1>
                <p>{i18n`not_found_description`} </p>
                <ActionButton
                    primary
                    className={styles["action-button"]}
                    onClick={() => handleClickGoBack(history)}
                >
                    {i18n`not_found_redirect`}
                </ActionButton>
                <ActionButton
                    primary
                    className={styles["go-home"]}
                    onClick={() => handleClickGoHome(history, locale)}
                >
                    {i18n`Home`}
                </ActionButton>
            </SovosBox>
        </SovosBox>
    );
};
export default connect(
    ({ user, fetch }) => ({
        user,
        fetch,
    }),
    {
        logout,
        setLocale,
    },
)(NotFound);
